/**
 * ==========================================================
 * IMPORTS
 * ==========================================================
 */

import ActionHandler

    from "../../../components/platform/auth/actionHandler/ActionHandler";

import "../../../style/platform/auth/actionHandlerPage.css";

/*
==========================================================
PAGE
==========================================================
*/

export default function ActionHandlerPage() {

    return (

        <main className="action-handler-page">

            <ActionHandler />

        </main>

    );

}